export default "__VITE_ASSET__DXBF3f1z__"